export class Loggin {
    utilisateur:String;
    nom_utilisateur:String;
    mot_de_pass:String;
    nouveau_mot_de_pass:String;
    confirmation_mot_de_pass:String;
    image: any;
    id : number;
    

    constructor(){
      
    }
}
